import React from 'react'
import Personalized from './Personalized'

import { connect } from 'react-redux'
import { actions } from './.'
import { getUserRecomendation } from '../reducer'

const mapStateToProps = ({ products, recomendation, availabilities }) => ({
  ...getUserRecomendation(products, recomendation, availabilities)
})

const mapDispatchToProps = dispatch => ({
  fetchUserRecomendation: () => dispatch(actions.fetchUserRecomendation())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(props => <Personalized {...props} />)



// WEBPACK FOOTER //
// ./src/features/Recomendation/Personalized/PersonalizedContainer.js